"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bicIsValid = void 0;
exports.checkInputProps = checkInputProps;
exports.creditCardIsValid = void 0;
exports.dateIsInBetweenDates = dateIsInBetweenDates;
exports.dateIsInNotInThePast = dateIsInNotInThePast;
exports.dateIsInTheFuture = dateIsInTheFuture;
exports.dateIsNotInTheFuture = dateIsNotInTheFuture;
exports.dateIsNotValid = dateIsNotValid;
exports.emailIsNotEqual = emailIsNotEqual;
exports.emailIsNotValid = emailIsNotValid;
exports.fieldIsEmpty = fieldIsEmpty;
exports.ibanIsValid = void 0;
exports.listOptionsAreValid = listOptionsAreValid;
exports.multiEmailIsNotValid = exports.minLengthNotReached = exports.maxLengthSurpassed = exports.matchesRegex = void 0;
exports.phoneIsNotValid = phoneIsNotValid;
exports.sortCodeIsValid = void 0;
exports.textIsNotAlphabetic = textIsNotAlphabetic;
exports.urlIsNotValid = urlIsNotValid;

var _googleLibphonenumber = require("google-libphonenumber");

var _cardValidator = _interopRequireDefault(require("card-validator"));

var _ibantools = require("ibantools");

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var mailformat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var sortCodeRegex = /^(?!(?:0{6}|00-00-00))(?:\d{6}|\d\d-\d\d-\d\d)$/;
var urlformat = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,24}(:[0-9]{1,5})?(\/.*)?$/g;
var alphabeticFormat = /^[A-Za-z\s]+$/g;

var normalizeDate = function normalizeDate(d) {
  return typeof d === 'string' ? Date.parse(d) : typeof d === 'number' ? d : undefined;
};

function fieldIsEmpty(inputText) {
  if (!inputText) return true;

  if (typeof inputText === 'string') {
    return inputText.replace(/\s/g, "").replace(/&nbsp;/g, '').replace(/<p>/g, '').replace(/<\/p>/g, '') === '';
  }

  if (typeof inputText === 'boolean') return true;
  return false;
}

function phoneIsNotValid(phoneNumber) {
  if (!phoneNumber) return false;
  var isNotValid = true;

  try {
    var phoneUtil = _googleLibphonenumber.PhoneNumberUtil.getInstance();

    isNotValid = !phoneUtil.isValidNumber(phoneUtil.parse(phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.toString()));
  } catch (e) {
    isNotValid = true;
  }

  return isNotValid;
}

function textIsNotAlphabetic(inputText) {
  if (!inputText) return false;
  return inputText.match(alphabeticFormat) === null;
}

function urlIsNotValid(url) {
  if (!url) return false;
  return url.match(urlformat) === null;
}

function listOptionsAreValid(type, list) {
  if (!type || !(type === 'SELECT' || type === 'MULTI_SELECT')) return false;else {
    if ((0, _lodash.isEmpty)(list)) return true;
    if (list && list.length < 2) return true;
  }
}

function emailIsNotValid(inputText) {
  if (!inputText) return false;
  return inputText.match(mailformat) === null;
}

var multiEmailIsNotValid = function multiEmailIsNotValid(inputText) {
  return inputText.split(/; |;/g).some(function (el) {
    return emailIsNotValid(el);
  });
};

exports.multiEmailIsNotValid = multiEmailIsNotValid;

function emailIsNotEqual(email, confirmEmail) {
  if (!email) return false;
  return email !== confirmEmail;
}

function dateIsNotInTheFuture(_ref) {
  var value = _ref.value,
      id = _ref.id;
  var currentTimestamp = Date.now();
  var valueDate = normalizeDate(value);
  if (!valueDate) return false;
  if (valueDate > currentTimestamp) return {
    key: id,
    value: 'errors.valueDateGreaterThanMax'
  };
}

function dateIsInNotInThePast(_ref2) {
  var value = _ref2.value,
      id = _ref2.id;
  var currentTimestamp = Date.now();
  var valueDate = normalizeDate(value);
  if (!valueDate) return false;
  if (valueDate < currentTimestamp) return {
    key: id,
    value: 'errors.valueDateLowerThanMin'
  };
} //Returns an error if date is not between dates
//If min or max is missing they are considered as infinite


function dateIsInBetweenDates(_ref3) {
  var value = _ref3.value,
      id = _ref3.id,
      min = _ref3.min,
      max = _ref3.max;
  var minDate = normalizeDate(min);
  var maxDate = normalizeDate(max);
  var valueDate = normalizeDate(value);
  if (!minDate && !maxDate || !valueDate) return false;
  if (maxDate && valueDate > maxDate) return {
    key: id,
    value: 'errors.valueDateGreaterThanMax'
  };
  if (minDate && valueDate < minDate) return {
    key: id,
    value: 'errors.valueDateLowerThanMin'
  };
}

function dateIsInTheFuture(_ref4) {
  var value = _ref4.value,
      id = _ref4.id,
      min = _ref4.min,
      max = _ref4.max;

  if (min !== undefined) {
    switch (_typeof(min)) {
      case 'string':
        return Date.parse(value) < Date.parse(min) && {
          key: id,
          value: 'errors.valueDateLowerThanMin'
        };

      case 'number':
        return value < min && {
          key: id,
          value: 'errors.valueLowerThanMin'
        };

      default:
        return false;
    }
  }

  if (max !== undefined) {
    switch (_typeof(max)) {
      case 'string':
        return Date.parse(value) > Date.parse(max) && {
          key: id,
          value: 'errors.valueDateGreaterThanMax'
        };

      case 'number':
        return value > max && {
          key: id,
          value: 'errors.valueGreaterThanMax'
        };

      default:
        return false;
    }
  }

  return false;
}

function dateIsNotValid(_ref5) {
  var value = _ref5.value,
      type = _ref5.type;

  switch (type) {
    case 'DATE':
    default:
      var yearRegEx = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
      return !value.match(yearRegEx);

    case 'MONTH':
      var monthRegEx = /^\d{4}-(0[1-9]|1[012])/;
      return !value.match(monthRegEx);

    case 'YEAR':
      if (value.length === 4 && value > 1800 && value < 2050) return false;else return true;
  }
}

function checkInputProps(_ref6) {
  var opts = _ref6.opts,
      min = _ref6.min,
      max = _ref6.max,
      id = _ref6.id,
      value = _ref6.value;

  if (min !== undefined) {
    switch (_typeof(min)) {
      case 'string':
        return Date.parse(value) < Date.parse(min) && {
          key: id,
          value: 'errors.valueDateLowerThanMin'
        };

      case 'number':
        return value < min && {
          key: id,
          value: 'errors.valueLowerThanMin'
        };

      default:
        return false;
    }
  }

  if (max !== undefined) {
    switch (_typeof(max)) {
      case 'string':
        return Date.parse(value) > Date.parse(max) && {
          key: id,
          value: 'errors.valueDateGreaterThanMax'
        };

      case 'number':
        return value > max && {
          key: id,
          value: 'errors.valueGreaterThanMax'
        };

      default:
        return false;
    }
  }

  return false;
}

var creditCardIsValid = function creditCardIsValid(value) {
  var card = _cardValidator.default.number(value);

  return card.isValid;
};

exports.creditCardIsValid = creditCardIsValid;

var ibanIsValid = function ibanIsValid(value) {
  return (0, _ibantools.isValidIBAN)(value.replace(/\s/g, ''));
};

exports.ibanIsValid = ibanIsValid;

var bicIsValid = function bicIsValid(value) {
  return (0, _ibantools.isValidBIC)(value);
};

exports.bicIsValid = bicIsValid;

var sortCodeIsValid = function sortCodeIsValid(value) {
  return value.match(sortCodeRegex);
};

exports.sortCodeIsValid = sortCodeIsValid;

var minLengthNotReached = function minLengthNotReached(value, minLength) {
  return value.length < minLength;
};

exports.minLengthNotReached = minLengthNotReached;

var maxLengthSurpassed = function maxLengthSurpassed(value, maxLength) {
  return value.length > maxLength;
};

exports.maxLengthSurpassed = maxLengthSurpassed;

var matchesRegex = function matchesRegex(value, regex) {
  return value.match(regex);
};

exports.matchesRegex = matchesRegex;